var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_10881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38573 7.42529H0.68457V11.4868H7.38573V7.42529Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4308 11.4868H6.70117V15.5483H12.4308V11.4868Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.931 15.4937H12.3164V19.5565H17.931V15.4937Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5453 19.5562H17.9307V23.619H23.5453V19.5562Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67539 0H5.72949V3.64958H7.67539V0Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9029 0H16.957V3.64958H18.9029V0Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2632 2.29371V4.42161H1.36842V2.29371H23.2632ZM24.6316 0.925293H0V5.79003H24.6316V0.925293Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8947 6.55615H2.73684C1.22611 6.55615 0 7.69194 0 9.09321V22.0932C0 23.4958 1.22611 24.6316 2.73684 24.6316H6.01695V24.6398H7.38537V24.6316H11.6316V24.6398H13V24.6316H17.2462V24.6398H18.6146V24.6316H21.8947C23.4055 24.6316 24.6316 23.4958 24.6316 22.0946V9.09457C24.6316 7.69194 23.4055 6.55615 21.8947 6.55615ZM23.2632 9.09321V18.8719H18.6146V7.92457H21.8947C22.6501 7.92457 23.2632 8.44868 23.2632 9.09321ZM7.38537 12.1708H11.6316V14.8638H7.38537V12.1708ZM7.38537 10.8024V7.92457H11.6316V10.8024H7.38537ZM13 16.2323H17.2462V18.8719H13V16.2323ZM13 14.8638V7.92457H17.2462V14.8638H13ZM2.73684 7.92457H6.01695V10.8024H1.36842V9.09321C1.36842 8.44868 1.98284 7.92457 2.73684 7.92457ZM2.73684 23.2632C1.98284 23.2632 1.36842 22.7377 1.36842 22.0946V12.1722H6.01695V23.2632H2.73684ZM7.38537 23.2632V16.2323H11.6316V23.2632H7.38537ZM13 23.2632V20.2404H17.2462V23.2632H13ZM21.8947 23.2632H18.6146V20.2404H23.2632V22.0932C23.2632 22.7377 22.6501 23.2632 21.8947 23.2632Z",
    fill: "#44A6E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_10881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6316,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.9e20a65fe79b51564d60dac163c621ad.svg";
export { ForwardRef as ReactComponent };